import {
  formatTonBubbleAmount,
  formatTonCompact,
} from "@/shared/lib/pvpRouletteMath"
import { cn } from "@/shared/lib"

import TonIcon from "@/assets/icons/ton-icon.svg?react"

export type PvpTonAmountPillFormat = "compact" | "bubble"

/**
 * `pill` — fully rounded capsule (default; existing TON-bet bubbles).
 * `tab`  — left side slightly rounded (`6px`), right side fully rounded
 *          (`24px`). Used for gift-bet bubbles where the pill abuts the
 *          gift thumbnail strip on its left.
 */
export type PvpTonAmountPillCornerStyle = "pill" | "tab"

interface PvpTonAmountPillProps {
  tonValue: number
  /** `compact` — один знак после запятой, целые без `.0`; `bubble` — то же для ленты над колесом. */
  format?: PvpTonAmountPillFormat
  cornerStyle?: PvpTonAmountPillCornerStyle
  className?: string
}

export const PvpTonAmountPill = ({
  tonValue,
  format = "compact",
  cornerStyle = "pill",
  className,
}: PvpTonAmountPillProps) => {
  const formatted =
    format === "bubble"
      ? formatTonBubbleAmount(tonValue)
      : formatTonCompact(tonValue)
  return (
    <span
      className={cn(
        "inline-flex h-[25px] shrink-0 items-center justify-center gap-0.5 bg-success-100 px-1",
        cornerStyle === "pill"
          ? "rounded-full"
          : "rounded-l-md rounded-r-[24px] pl-1.5 pr-1",
        className
      )}
    >
      <span className="text-sm/none font-semibold tabular-nums tracking-[-0.5px] text-white">
        +{formatted}
      </span>
      <TonIcon className="size-4 shrink-0" />
    </span>
  )
}
